import {
	desktopLMediaQuery,
	desktopMediaQuery,
	device,
	laptopMediaQuery,
	mobileMediaQuery,
	tabletMediaQuery,
} from "@helpers";
import type { IModuleImageFields } from "@types-contentful";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative !important;
  width: 100%;
`;

const Image = styled.img`
  object-fit: cover;
  width: 100%;
  ${mobileMediaQuery} {
    height: 174px;
  }

  ${tabletMediaQuery} {
    height: 370px;
  }

  @media (min-width: ${device.laptop}) {
    height: 650px;
  }
`;

const ContentfulModuleImage = ({ imageRef }: IModuleImageFields) => {
	const image = imageRef || {};
	const renderMainImage = () => (
		<Image
			src={`https://${image.fields?.file?.url}`}
			alt={image?.fields?.description}
			loading="lazy"
		/>
	);
	return <>{<Container>{renderMainImage()}</Container>}</>;
};

export default ContentfulModuleImage;
